import { pages, subPackages, tabBar } from '@/pages.json'
export const getLastPage = () => {
  // getCurrentPages() 至少有1个元素，所以不再额外判断
  // const lastPage = getCurrentPages().at(-1)
  // 上面那个在低版本安卓中打包回报错，所以改用下面这个【虽然我加了src/interceptions/prototype.ts，但依然报错】
  const pages = getCurrentPages()
  return pages[pages.length - 1]
}

/**
 * 子页面回退传参
 * @param methodName 父级回调名称
 * @param params 传递给父级的参数
 * @param delta 返回层数,默认返回上一页
 */
export const sonSendToParent = (
  params: any,
  methodName: string = 'reBackData',
  delta: number = 1,
) => {
  var pages = getCurrentPages()
  var prevPage: any = pages[pages.length - (delta + 1)]
  prevPage.$vm._.exposed[methodName](params)
  uni.navigateBack({
    delta: delta,
  })
}

/** 判断当前页面是否是tabbar页  */
export const getIsTabbar = () => {
  if (!tabBar) {
    return false
  }
  if (!tabBar.list.length) {
    // 通常有tabBar的话，list不能有空，且至少有2个元素，这里其实不用处理
    return false
  }
  const lastPage = getLastPage()
  const currPath = lastPage.route
  return !!tabBar.list.find((e) => e.pagePath === currPath)
}

/**
 * 获取当前页面路由的 path 路径和 redirectPath 路径
 * path 如 ‘/pages/login/index’
 * redirectPath 如 ‘/pages/demo/base/route-interceptor’
 */
export const currRoute = () => {
  const lastPage = getLastPage()
  const currRoute = (lastPage as any).$page
  // console.log('lastPage.$page:', currRoute)
  // console.log('lastPage.$page.fullpath:', currRoute.fullPath)
  // console.log('lastPage.$page.options:', currRoute.options)
  // console.log('lastPage.options:', (lastPage as any).options)
  // 经过多端测试，只有 fullPath 靠谱，其他都不靠谱
  const { fullPath } = currRoute as { fullPath: string }
  // console.log(fullPath)
  // eg: /pages/login/index?redirect=%2Fpages%2Fdemo%2Fbase%2Froute-interceptor (小程序)
  // eg: /pages/login/index?redirect=%2Fpages%2Froute-interceptor%2Findex%3Fname%3Dfeige%26age%3D30(h5)
  return getUrlObj(fullPath)
}

const ensureDecodeURIComponent = (url: string) => {
  if (url.startsWith('%')) {
    return ensureDecodeURIComponent(decodeURIComponent(url))
  }
  return url
}
/**
 * 解析 url 得到 path 和 query
 * 比如输入url: /pages/login/index?redirect=%2Fpages%2Fdemo%2Fbase%2Froute-interceptor
 * 输出: {path: /pages/login/index, query: {redirect: /pages/demo/base/route-interceptor}}
 */
export const getUrlObj = (url: string) => {
  const [path, queryStr] = url.split('?')
  // console.log(path, queryStr)

  if (!queryStr) {
    return {
      path,
      query: {},
    }
  }
  const query: Record<string, string> = {}
  queryStr.split('&').forEach((item) => {
    const [key, value] = item.split('=')
    // console.log(key, value)
    query[key] = ensureDecodeURIComponent(value) // 这里需要统一 decodeURIComponent 一下，可以兼容h5和微信y
  })
  return { path, query }
}
/**
 * 得到所有的需要登录的pages，包括主包和分包的
 * 这里设计得通用一点，可以传递key作为判断依据，默认是 needLogin/noNeedLogin, 与 route-block 配对使用
 * 如果没有传 key，则表示所有的pages，如果传递了 key, 则表示通过 key 过滤
 */
export const getAllPages = (key = 'needLogin') => {
  // 这里处理主包
  const mainPages = [
    ...pages
      .filter((page) => !key || page[key])
      .map((page) => ({
        ...page,
        path: `/${page.path}`,
      })),
  ]
  // 这里处理分包
  const subPages: any[] = []
  subPackages.forEach((subPageObj: any) => {
    // console.log(subPageObj)
    const { root } = subPageObj

    subPageObj.pages
      .filter((page) => !key || page[key])
      .forEach((page: { path: string } & Record<string, any>) => {
        subPages.push({
          ...page,
          path: `/${root}/${page.path}`,
        })
      })
  })
  const result = [...mainPages, ...subPages]
  // console.log(`getAllPages by ${key} result: `, result)
  return result
}

/**
 * 得到所有的需要登录的pages，包括主包和分包的
 * 只得到 path 数组
 */
export const getNeedLoginPages = (): string[] => getAllPages('needLogin').map((page) => page.path)

/**
 * 得到所有的不需要登录的pages，包括主包和分包的
 * 只得到 path 数组
 */
export const getNoNeedLoginPages = (): string[] =>
  getAllPages('noNeedLogin').map((page) => page.path)

export function get(key: string) {
  const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`, 'i')
  const string = window.location.href
  const stringKey = string.split('?')[1]
  if (!stringKey) return null
  const r = stringKey.match(reg)
  if (r != null) return decodeURI(r[2])
  return null
} // GET:获取url参数
export function saveLocal(key: string, obj: any) {
  obj instanceof Object
    ? uni.setStorageSync(key, JSON.stringify(obj))
    : uni.setStorageSync(key, obj)
} // 保存数据到本地
export function getLocal(key: string) {
  const data: any = uni.getStorageSync(key)
  try {
    return JSON.parse(data)
  } catch (err) {
    return data
  }
} // 获取本地数据
export function delLocal(key: string) {
  uni.removeStorageSync(key)
} // 删除本地数据

export function findItem(arr: any[], id: any, idKey: string) {
  if (!arr) {
    return false
  }
  const Item = arr.find(function (x) {
    return x[idKey] == id
  })
  return Item
} // findItme(arr, id, idkey) 查询/查找根据id 找Itme 返回这个id的对象

/**
 * @description 剔除对象中值为null的数据并返回一个新的对象
 * @param data
 */
export function getValuesOfObject(data) {
  let obj = {}
  for (let key in data) {
    if ([null, '', undefined].indexOf(data[key]) === -1) {
      if (!(data[key] instanceof Array && !data[key][0])) {
        obj[key] = data[key]
      }
    }
  }
  if (Object.values(obj).length > 0) {
    return obj
  } else {
    return null
  }
}
// 反馈状态
export function transformSendStatus(row: any) {
  switch (row?.sendStatus) {
    case '0':
      return {
        text: '未发送',
        color: 'orange',
      }
    case '1':
      if (row?.doctorReadStatus == '0') {
        return {
          text: '未读',
          color: 'green',
        }
      } else if (row?.doctorReadStatus == '1') {
        return {
          text: '已读',
          color: 'green',
        }
      }
    case '2':
      return {
        text: '草稿',
        color: '',
      }
    default:
      return {
        text: '--',
        color: '',
      }
  }
}
// 批改状态
export function transformCorrectState(state: any) {
  switch (state) {
    case '0':
      return {
        text: '草稿',
        color: 'purple',
      }
    case '1':
      return {
        text: '待批改',
        color: 'orange',
      }
    case '2':
      return {
        text: '通过',
        color: 'green',
      }
    case '3':
      return {
        text: '打回修改',
        color: 'red',
      }
    case '4':
      return {
        text: '老师修改',
        color: 'green',
      }
    default:
      return {
        text: '--',
        color: '',
      }
  }
}

// 防抖函数的实现
export function debounce(fn: any) {
  let timer: any = null
  if (timer) {
    clearTimeout(timer)
  }
  timer = setTimeout(() => {
    fn()
  }, 500)
}

// 判断字符串是否base64编码
export function isBase64(str: any) {
  const regex = /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/
  return regex.test(str)
}

// 脱敏
export function desensitize(str: any, type: any) {
  if (type === 'phone') {
    return str
      ? str.replace(/(\S{3})(\S*)(\S{4})/, '$1' + new Array(str.length - 6).join('*') + '$3')
      : ''
  } else if (type === 'idCard') {
    return str ? str.replace(/(\d{3})(\d*)(\d{2})/, '$1' + new Array(15).join('*') + '$3') : ''
  } else if (type === 'address') {
    if (str) {
      const index = str.indexOf('市')
      if (index > -1) {
        return str.substr(0, index + 1) + new Array(str.length - index).join('*')
      } else {
        return str
      }
    } else {
      return ''
    }
  }
}

// base64加密
export function witEncode(str: any) {
  return str ? 'YsGzZjM' + $be(str) : ''
}

// base64解密
export function witDecode(str: any) {
  return str ? $bd(str.substr(7, str.length - 1)) : ''
}
